/**
 * Chart.js configuration constants extracted from SCSS :export block.
 * These values are used for consistent chart styling across the dashboard.
 */

export const CHART_CONFIG = {
  tooltip: {
    bgColor: '#1a2538',
    textColor: '#fff',
    fontSize: 12,
    titleFontWeight: 'bold' as const,
    paddingY: 6,
    paddingX: 8,
    titleMarginBottom: 4,
  },
  line: {
    // Using CSS variable reference for theming support
    color: '#4080ec', // --color-primary-40
    width: 2,
  },
  grid: {
    color: '#e5e7e9', // --color-gray-blue-10
  },
  ticks: {
    color: '#4d5664', // --color-gray-blue-70
    padding: 8,
  },
  verticalHoverLine: {
    color: '#e5e7e9', // --color-gray-blue-10
  },
} as const;

// Export individual values for backward compatibility with existing chart config
export const chartStyles = {
  tooltipBgColor: CHART_CONFIG.tooltip.bgColor,
  tooltipTextColor: CHART_CONFIG.tooltip.textColor,
  tooltipFontSize: CHART_CONFIG.tooltip.fontSize,
  tooltipTitleFontWeight: CHART_CONFIG.tooltip.titleFontWeight,
  tooltipPaddingY: CHART_CONFIG.tooltip.paddingY,
  tooltipPaddingX: CHART_CONFIG.tooltip.paddingX,
  tooltipTitleMarginBottom: CHART_CONFIG.tooltip.titleMarginBottom,
  chartLineColor: CHART_CONFIG.line.color,
  chartLineWidth: CHART_CONFIG.line.width,
  chartGridColor: CHART_CONFIG.grid.color,
  chartAxisTicksColor: CHART_CONFIG.ticks.color,
  chartAxisTicksPadding: CHART_CONFIG.ticks.padding,
  chartVerticalHoverLineColor: CHART_CONFIG.verticalHoverLine.color,
};
